// LottieAnimation.tsx
import lottie, { AnimationItem } from 'lottie-web'
import React, { useEffect, useRef } from 'react'
import { LottieNoImage } from '../../assets'

interface LottieAnimationProps {
    animationData?: object // The Lottie JSON animation data
    loop?: boolean
    autoplay?: boolean
    setDefaultSize?: boolean
    style?: React.CSSProperties
}

const LoadingAnimation: React.FC<LottieAnimationProps> = ({
    animationData = LottieNoImage,
    loop = true,
    autoplay = true,
    setDefaultSize = true,
    style
}) => {
    const containerRef = useRef<HTMLDivElement | null>(null)
    const animationRef = useRef<AnimationItem | null>(null)

    useEffect(() => {
        if (!containerRef.current) return

        animationRef.current = lottie.loadAnimation({
            container: containerRef.current,
            renderer: 'svg',
            loop,
            autoplay,
            animationData,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            }
        })

        return () => {
            if (animationRef.current) {
                animationRef.current.destroy()
            }
        }
    }, [animationData, loop, autoplay])

    return (
        <div
            ref={containerRef}
            style={
                setDefaultSize
                    ? {
                          width: '10rem',
                          height: '10rem',
                          margin: 'auto'
                      }
                    : style
            }
        />
    )
}

export default LoadingAnimation
